<template>

    <div class="consent__page-container container-b">

        <mq-layout class="full" mq="lg">

            <header-band
                :back="true"
                :blueCleanfox="true"
                :title="'Cleanfox'"
                @eventBack="back"
            ></header-band>

        </mq-layout>

        <div class="new-consent">

            <div class="content">

                <div class="bloc-consent">

                    <p class="text-xlSemibold">{{ $t('your_consent_share_data') }}</p>

                </div>

                <div class="bloc-overflow">

                    <div class="subtitle">
                        <img src="/img/icons/lock-blue.svg">
                        <span>{{ $t('how_works_data_title') }}</span>
                    </div>

                    <markdown :text="$t('consent_block_1')" class="paragraph mt__8"
                              :blank="true"></markdown>

                    <div class="subtitle mt__16">
                        <img src="/img/icons/question-blue.svg">
                        <span>{{ $t('how_works_title') }}</span>
                    </div>

                    <markdown :text="$t('consent_block_2')" class="paragraph mt__8"
                              :blank="true"></markdown>


                </div>

                <div class="bloc-consent">

                    <markdown :text="newConsentLegalLinks" :blank="true"></markdown>
                    <p class="mt__8">{{$t('click_lets_go')}}</p>

                    <button class="cta mt__16" @click="loginPage">
                        <lottie-loader :size="24" v-if="loader"></lottie-loader>
                        <span v-else>{{ $t('consent_cleanfox_lets_go') }}</span>
                    </button>
                </div>

            </div>

        </div>
    </div>

</template>

<script>
import Vuex from 'vuex'

import Consent from '../modules/consent'
import SessionStorage from '../helpers/sessionStorage'

import Auth from '../modules/auth'
import I18n from '../modules/i18n'
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import HeaderBand from '../components/headers/HeaderBand'
import LottieLoader from '../components/lottie/LottieLoader'
import Markdown from '../components/Markdown'


export default {

    name: 'consent-page',

    components: {LottieLoader, HeaderBand, Markdown},

    computed: {
        ...Vuex.mapGetters([
            'page'
        ]),
        newConsentLegalLinks() {
            return this.clearStaticLinksRedirection(this.$t('new_consent_legal_links'))
        }
    },

    data() {
        return {
            provider: '',
            toPath: '',
            invalidGrant: false,
            errorInConsentApi: false,
            loader: false,
            privacyTarget: 'privacy',
            showText: false
        }
    },

    created() {
        this.provider = this.$route.query.provider
        this.toPath = this.$route.query.toPath
    },

    async mounted() {
        // scroll top for Iphone
        window.scrollTo(0, 0)
        Tag.pageViewGA(this, 'consent')
        UserFlow.setPage(this, 'consent')
        this.showText = true
    },

    methods: {

        async loginPage() {
            const email = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
            const lang = I18n.get(this)
            this.errorInConsentApi = false
            try {
                this.loader = true
                await Auth.validConsent(lang, email)
            } catch (error) {
                this.errorInConsentApi = true
                this.loader = false
                return
            }

            Consent.acceptConsent(email)
            Tag.clickAll(this, 'accept', this.provider, this.page)
            Tag.firstProvider(this, this.provider)
            this.nextPage()
        },

        nextPage() {
            this.routerPush(this.toPath)
        },

        back() {

            Tag.clickGA(this, 'back', this.provider)

            this.$router.push('/')
        }
    }
}
</script>

<style lang="scss" scoped>

.consent__page-container {
    display: flex;
    flex-direction: column;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-image: url(/img/background/cards-desktop.svg);
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
        background-blend-mode: luminosity;
    }
}

.error {
    color: red;
    text-align: center;
}

.new-consent {
    height: 100vh;
    padding: 30px 20px 50px;
    background-color: $forest;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: $neutralsMoon;
    flex: 1;
    display: flex;
    text-align: start;
    align-items: center;
    justify-content: center;
    background-image: url('/img/background/consent.svg');
    background-position: bottom;
    background-size: contain;
    background-repeat: no-repeat;

    @media screen and (min-width: $above-tablet-length) {
        background: unset;
    }

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        background-color: $white;
        border-radius: 16px;
        padding-top: 4px;
        max-width: 512px;
        max-height: 95vh;
        @media screen and (min-width: $above-tablet-length) {
            height: fit-content;
        }

        .bloc-consent {
            padding: 16px;

            h1 {
                font-size: 20px;
                font-style: normal;
                font-weight: 700;
                line-height: 28px;
                color: $rifle;
            }

            .cta {
                width: 100%;
                min-height: 56px;
                padding: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $aquamarine;
                border-radius: 32px;
                font-size: 17px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
                color: $white;
            }
        }

        .bloc-overflow {
            border: 1px solid $silver;
            padding: 16px;
            flex: 1;
            overflow-y: scroll;
            @media screen and (min-width: $above-tablet-length) {
                flex: none;
            }

            .gap {
                height: 16px;
            }
        }

        .paragraph {
            margin-top: 4px;
        }

        .end-paragraph {
            margin-top: 8px;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
        }

        .subtitle {
            color: $rifle;
            font-size: 17px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            display: flex;
            align-content: center;

            > img {
                width: 20px;
                object-fit: contain;
                margin-right: 4px;
            }
        }
    }
}

.container-b {
    @media screen and (min-width: $above-tablet-length) {
        background: $alice-blue;
    }
}

</style>
